module.exports = __webpack_public_path__ + "img/flt_pt_hex_setsku.prt.7133e2e5.jpg";